import { DimensionPropsWeb } from './DimensionProps';

const dimension: DimensionPropsWeb = {
  spacing: {
    xxxl: {
      value: 3.75,
      get rem() {
        return `${this.value}rem`;
      },
    },
    xxl: {
      value: 3.125,
      get rem() {
        return `${this.value}rem`;
      },
    },
    xl: {
      value: 2.5,
      get rem() {
        return `${this.value}rem`;
      },
    },
    l: {
      value: 1.875,
      get rem() {
        return `${this.value}rem`;
      },
    },
    m: {
      value: 1.5625,
      get rem() {
        return `${this.value}rem`;
      },
    },
    s: {
      value: 1.25,
      get rem() {
        return `${this.value}rem`;
      },
    },
    xs: {
      value: 0.9375,
      get rem() {
        return `${this.value}rem`;
      },
    },
    xxs: {
      value: 0.625,
      get rem() {
        return `${this.value}rem`;
      },
    },
    xxxs: {
      value: 0.3125,
      get rem() {
        return `${this.value}rem`;
      },
    },
  },
  contentSize: {
    xl: {
      value: 1800,
      get px() {
        return `${this.value}px`;
      },
    },
    l: {
      value: 1200,
      get px() {
        return `${this.value}px`;
      },
    },
    m: {
      value: 800,
      get px() {
        return `${this.value}px`;
      },
    },
    s: {
      value: 600,
      get px() {
        return `${this.value}px`;
      },
    },
  },
  zIndex: {
    basis: 1000,
    sticky: 1100,
    fixed: 1200,
    tooltip: 1300,
    layerBackground: 1400,
    layer: 9020, // [NTD-472] TODO: Change back to 1450 if CM7 has problems with layer styling
    notification: 9030, // TODO use 1460, when layer is changed to 1450
  },
};

export default dimension;
